import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export const GridWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: left;
  margin: 0 -10px;

  & > * {
    width: 100%;
    padding: 0 10px;

    ${media.md`
      width: 50%;
    `}

    ${media.lg`
      width: 33.33%;
    `}
  }
`;

export const FeaturedItemWrapper = styled.div`
  padding: 10px;
`;
